import * as React from 'react';

import './ResultList.css';

import {
  IHit,
  ISearchReply,
} from '../api';
import { ResultRow } from './ResultRow';

interface IProps {
  currentRecordingID: string | null,
  results: ISearchReply,
  onSelect: (hit: IHit) => void,
  onPreview: (hit: IHit) => void,
}

class ResultList extends React.Component<IProps> {

  public render() {
    const {
      currentRecordingID,
      results,
      onSelect,
      onPreview,
    } = this.props;

    return (
      <div className="result-page">
        {results.hits.map((result, i) => (
          <ResultRow
            onSelect={ onSelect }
            onPreview={ onPreview }
            key={i}
            playing={ result.recording_id === currentRecordingID }
            result={result}/>
        ))}
      </div>
      );
  }

}

export default ResultList;



// WEBPACK FOOTER //
// ./src/components/ResultList.tsx